import React from 'react';
import config from 'react-global-configuration';

import { View } from '@uncinc/react-drupal-core';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { DOMAIN_VNL } from '../../../config/constants';

import './style.scss';

const DossierMenuOverview = ({ entity }) => {

  const activeDomain = config.get('CURRENT_DOMAIN_DRUPAL_IDENTIFIER');

  return (
    <div className="Paragraph ParagraphDossierMenuOverview">
      <Container>
        <div className="row">
          <div className="col-12">
            <h2>Onderwerpen</h2>
            <View id="vocabulary_terms" display="subject" args={[activeDomain]} />

            {(config.get('CURRENT_DOMAIN') === DOMAIN_VNL) && (
              <>
                <h2>Werkvelden</h2>
                <View id="vocabulary_terms" display="workfield" />
              </>
            )}
            {(config.get('CURRENT_DOMAIN') !== DOMAIN_VNL) && (
              <>
                <h2>Levensfases</h2>
                <View id="vocabulary_terms" display="stage_of_life" />
              </>
            )}
            {(config.get('CURRENT_DOMAIN') !== DOMAIN_VNL) && (
              <>
                <h2>Locaties</h2>
                <View id="vocabulary_terms" display="location" />
              </>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default DossierMenuOverview;
